import { FC } from "react";
import { StyledDivider } from "./Divider.styled";

interface Props {
  direction: string;
}
const Divider: FC<Props> = ({ direction }) => (
  <StyledDivider direction={direction} />
);

export default Divider;
